import { LODE_STAR_FEE_TYPES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const lodeStarfeeTypesReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case LODE_STAR_FEE_TYPES_ACTION_TYPE.GET_LODE_STAR_FEE_TYPES:
      return { ...state, [meta.feeTypeId]: payload };

    case LODE_STAR_FEE_TYPES_ACTION_TYPE.CREATE_LODE_STAR_FEE_TYPE:
      return { ...state, [meta.feeTypeId]: [...(state[meta.feeTypeId] || []), payload] };

    case LODE_STAR_FEE_TYPES_ACTION_TYPE.EDIT_LODE_STAR_FEE_TYPE:
      return {
        ...state,
        [meta.feeTypeId]: state[meta.feeTypeId].map(item =>
          item.lodeStarFeeTypeId === meta.lodeStarFeeTypeId ? payload : item,
        ),
      };

    case LODE_STAR_FEE_TYPES_ACTION_TYPE.DELETE_LODE_STAR_FEE_TYPE:
      return {
        ...state,
        [meta.feeTypeId]: state[meta.feeTypeId].filter(
          ({ lodeStarFeeTypeId }) => lodeStarFeeTypeId !== meta.lodeStarFeeTypeId,
        ),
      };

    default:
      return state;
  }
};

export default lodeStarfeeTypesReducer;
